import React from 'react';
import { COVERAGE_META } from '../utils/signalCoverage';

/**
 * A small "data truth" tag — e.g. LIVE, ESTIMATED, BACKUP, PLACEHOLDER, DEMO.
 * Used on each signal-component card so users always know how real that input is.
 */
export default function CoverageBadge({ coverage, size = 'sm', showDot = true, title }) {
  const meta = COVERAGE_META[coverage] || COVERAGE_META.demo;
  const pad = size === 'xs' ? 'px-1.5 py-0.5 text-[9px]' : 'px-2 py-0.5 text-[10px]';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-display font-bold uppercase tracking-wider ${pad}`}
      style={{
        color: meta.color,
        backgroundColor: `${meta.color}1a`,
        border: `1px solid ${meta.color}40`,
      }}
      title={title || meta.tip}
    >
      {showDot && <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />}
      {meta.label}
    </span>
  );
}
